import { useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';

export const useShipForms = () => {
    const [shipForms, setShipForms] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchShipForms = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await axiosInstance.get('/api/shipping-methods');
            setShipForms(response.data.data);
        } catch (err) {
            console.error('Error fetching active shipping forms:', err);
            setError(err.message || 'Failed to fetch active shipping forms');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchShipForms();
    }, []);

    return {
        shipForms,
        loading,
        error,
        refetch: fetchShipForms
    };
}; 